import Glide from "@glidejs/glide";
import feather from "feather-icons";

(function ($) {
  $(document).ready(function () {
    let postsGlide = document.querySelector(".services__glide");

    if (postsGlide) {
      let glidePosts = new Glide(".services__glide", {
        type: "carousel",
        perView: 4,
        breakpoints: {
          1040: {
            perView: 3,
          },
          768: {
            perView: 2,
          },
          576: {
            perView: 1,
          },
        },
      });

      glidePosts.mount();
    }

    feather.replace();
  });
})(jQuery);
